import { render } from "./SkillsRadarChart.vue?vue&type=template&id=6332ee26&scoped=true"
import script from "./SkillsRadarChart.vue?vue&type=script&lang=js"
export * from "./SkillsRadarChart.vue?vue&type=script&lang=js"

import "./SkillsRadarChart.vue?vue&type=style&index=0&id=6332ee26&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6332ee26"]])

export default __exports__